module.exports = {"360703001":"蓉江街道","360703002":"东山街道","360703100":"唐江镇","360703101":"凤岗镇","360703103":"龙岭镇","360703104":"龙回镇","360703105":"镜坝镇","360703106":"横市镇","360703200":"浮石乡","360703201":"赤土畲族乡","360703202":"横寨乡","360703203":"朱坊乡","360703204":"太窝乡","360703205":"三江乡","360703206":"龙华乡","360703207":"十八塘乡","360703208":"麻双乡","360703209":"大坪乡","360703210":"坪市乡","360703211":"隆木乡","360703400":"南康市工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360703.json
// module id = 1187
// module chunks = 0